export * from './settings';
export * from './settings-dictionary';
export * from './settings-provider';
export * from './test-card';
export const supportedLanguages = ['en', 'es', 'de', 'ja', 'pl', 'pt_BR', 'zh_CN', 'ru', 'fi', 'fr', 'ko', 'id', 'it'];
